var React = require('react');

function Pl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m256 512c141.38 0 256-114.63 256-256s-114.62-256-256-256-256 114.63-256 256 114.62 256 256 256z","fill":"#f0f0f0","key":0}),React.createElement("path",{"d":"m512 256c0 141.37-114.63 256-256 256s-256-114.62-256-256","fill":"#d80027","key":1})]);
}

Pl.defaultProps = {"viewBox":"0 0 512 512.01","data-name":"Слой 1"};

module.exports = Pl;

Pl.default = Pl;
